import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useDispatch} from 'react-redux';
import {ERROR_CODES} from 'src/components/authentication/errors';
import {getUserDetails} from 'src/action-creators/referrer-portal/authentication';
import * as reduxApi from 'src/utils/redux-api-referrer-portal';
import {
  type FileObject,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FileUpload,
  Button,
  Link,
  InContextAlert,
} from '@spaced-out/ui-design-system/lib/components/index';

import css from 'src/components/referrer-portal/settings/settings.css';


type FileUploadCallbacks = {
  onProgress: (arg1: number) => void;
  onSuccess: () => void;
  onError: (arg1: string) => void;
};

const UploadProfile = ({isEdit}: {isEdit?: boolean}) => {
  const dispatch = useDispatch();
  const {t} = useLabelTranslation();

  const [file, setFile] = React.useState<any>(null);
  const [apiError, setApiError] = React.useState<any>(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleFileUpload = async (
    fileObject?: FileObject | null,
    callbacks?: FileUploadCallbacks | null,
  ) => {
    if (!fileObject) {
      return;
    }
    callbacks?.onProgress(40);
    callbacks?.onProgress(100);
    callbacks?.onSuccess();
    setFile(fileObject.file);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    if (!file) {
      return;
    }
    const fileType = file.type.split('/')[1];

    formData.append('image', file);
    formData.append('file_type', fileType);
    dispatch(reduxApi.post('user/picture', formData))
      .then(() => {
        setIsModalOpen(false);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        dispatch(getUserDetails());
      })
      .catch((error) => {
        if (error?.responseBody?.message) {
          setApiError(error.responseBody.message);
        }
      });
  };

  return (
    <>
      <Link as="buttonTextMedium" onClick={() => setIsModalOpen(true)}>
        {isEdit ? t('Edit', 'Edit') : t('Add', 'Add')}
        {` ${t('Profile_picture', 'Profile picture')}`}
      </Link>

      <Modal size="medium" isOpen={isModalOpen}>
        <ModalHeader onCloseButtonClick={() => setIsModalOpen(false)}>
          {t('Profile_Picture', 'Profile Picture')}
        </ModalHeader>
        <ModalBody className={css.flexColumn}>
          <FileUpload
            label={t('Upload_Profile_Picture', 'Upload Profile Picture')}
            instruction={t(
              'The_file_size_should_be_less_than_1_MB',
              'The file size should be less than 1 MB',
            )}
            secondaryInstruction={t(
              'Types_png_jpeg_Max_size_1mb',
              'Types: .png, .jpeg   Max. size: 1mb',
            )}
            maxSize={1000000}
            accept={{'image/jpeg': ['.jpg', '.jpeg'], 'image/png': ['.png']}}
            // @ts-expect-error - TS17001 - JSX elements cannot have multiple attributes with the same name.
            instruction={file?.name}
            // @ts-expect-error - TS2769 - No overload matches this call. | TS7006 - Parameter 'fileObjectArray' implicitly has an 'any' type. | TS7006 - Parameter 'callbacks' implicitly has an 'any' type.
            onValidFilesDrop={(fileObjectArray, callbacks) => {
              handleFileUpload(fileObjectArray[0], callbacks);
            }}
            onRejectedFilesDrop={() => {
              handleFileUpload(null);
            }}
            classNames={{wrapper: css.fileUpload}}
          />
          {apiError && (
            <InContextAlert semantic="danger" classNames={{wrapper: css.alert}}>
              {/* @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly InvalidLoginAttempt: "Incorrect email or password"; readonly ServerError: "Failed to perform action, Please try after sometime"; readonly IncorrectOTP: "Invalid OTP entered"; ... 13 more ...; readonly InvalidReferrerEmail: "Invalid Referrer Email"; }'. */}
              {ERROR_CODES[apiError] || apiError}
            </InContextAlert>
          )}
        </ModalBody>
        <ModalFooter>
          <Button type="ghost" onClick={() => setIsModalOpen(false)}>
            {t('Cancel', 'Cancel')}
          </Button>
          <Button disabled={!file} onClick={handleSubmit}>
            {t('Save', 'Save')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default UploadProfile;
